import baseTheme from '../baseTheme';
export var MuiPaper = {
    root: {
        color: baseTheme.palette.text.primary,
    },
    elevation0: {
        border: "1px solid " + baseTheme.palette.grey[300],
    },
    rounded: {
        borderRadius: 8,
    },
};
//# sourceMappingURL=MuiPaper.js.map